import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  public immersiveState: BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() { }
  
}
